// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3088":"fa4b2b86","3110":"c97a1376","6243":"fa4b2b86"}[chunkId] + ".chunk.css";
};